import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

export const Wrapper = styled.div`
  width: 90%;
  margin: 2rem 0 0 0;
  padding: 0 1rem;

  ${themeMedia.desktop`
    width: auto;
  `};
`

export const Row = styled.div`
  display: flex;
  padding: 1rem 0;
  gap: 20px;
  border-bottom: 1px solid ${themeStyles.colors.lightGreys[3].main};
`

export const Col = styled.div`
  width: 50%;
  flex: 1 1 50%;
  text-align: ${(props) => props.align || 'left'};
`

export const Bold = styled.div`
  width: 50%;
  flex: 1 1 50%;
  font-weight: 600;
`

export const Error = styled.div`
  text-align: center;

  svg {
    display: block;
    width: 2em !important;
    height: 2em;
    margin: 1rem auto;
  }
`

export const StatusColor = styled.div`
  color: ${themeStyles.colors.black.main};
  width: 50%;
  flex: 1 1 50%;
  text-align: ${(props) => props.align || 'left'};

  ${(props) => {
    switch (props.status) {
      case 'pending':
        return `color: ${themeStyles.colors.accentColors.secondary.main};`
      case 'success':
        return `color: ${themeStyles.colors.success.main};`
      case 'error':
      case 'declined':
      case 'cancelled':
        return `color: ${themeStyles.colors.error.main};`
      default:
        return `color: ${themeStyles.colors.black.main};`
    }
  }}
`

export const ButtonWrapper = styled.div`
  text-align: center;
  padding: 1rem 0;
`
